// extracted by css-extract-rspack-plugin
var _1 = "g_zET";
export { _1 as "absolutePosition" }
